import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { ProtectedRoute, LazyLoad } from '../routeGuards';
import {
  GameAndPackagePage,
  PackageByGameIDPage,
  SortGamesPage,
  BusinessSortPackagesPage,
} from '../lazyPages';

export function BusinessGameAndPackageRoutes() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const name = new URLSearchParams(search).get('name');

  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            pageName={t('BUSINESS_SIDEBAR.MANAGE_GAME_AND_PACKAGE')}
          >
            <LazyLoad>
              <GameAndPackagePage />
            </LazyLoad>
          </ProtectedRoute>
        }
      />
      <Route
        path="sort-games"
        element={
          <ProtectedRoute pageName={t('GAME_AND_PACKAGE.SORT_GAMES.TITLE')}>
            <LazyLoad>
              <SortGamesPage />
            </LazyLoad>
          </ProtectedRoute>
        }
      />
      <Route
        path="package/:id"
        element={
          <ProtectedRoute
            pageName={name || t('BUSINESS_SIDEBAR.MANAGE_GAME_AND_PACKAGE')}
          >
            <LazyLoad>
              <PackageByGameIDPage />
            </LazyLoad>
          </ProtectedRoute>
        }
      />
      <Route
        path="package/:id/sort"
        element={
          <ProtectedRoute pageName={t('GAME_AND_PACKAGE.SORT_PACKAGES.TITLE')}>
            <LazyLoad>
              <BusinessSortPackagesPage />
            </LazyLoad>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}
